<template>
  <section id="impressum" class="py-5">
    <!-- Einleitung -->
    <div class="intro-text text-center mb-5">
      <h2><i class="fas fa-file-alt"></i> Impressum</h2>
    </div>

    <!-- Hauptinhalt des Impressums -->
    <div class="container">
      <!-- Angaben gemäß §5 TMG -->
      <div class="bs-docs-section mb-5">
        <h3><i class="fas fa-info-circle"></i> Angaben gemäß §5 TMG</h3>
        <p>
          Crafting Systems GmbH<br>Neustr. 64, 41836 Hückelhoven<br>Amtsgericht Mönchengladbach HRB 21983<br>Steuernummer:
          208/5702/1783 (Finanzamt Erkelenz)
        </p>
        <p>
          <b>Vertreten durch:</b><br>Dr.-Ing. André Pomp<br>Dr.-Ing. Alexander Paulus
        </p>
      </div>

      <!-- Kontakt -->
      <div class="bs-docs-section mb-5">
        <h3><i class="fas fa-envelope"></i> Kontakt</h3>
        <p>
          E-Mail: <a href="mailto:info@crafting-systems.de">info@crafting-systems.de</a>
        </p>
      </div>

      <!-- Haftung für Inhalte -->
      <div class="bs-docs-section mb-5">
        <h3><i class="fas fa-exclamation-triangle"></i> Haftung für Inhalte</h3>
        <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
          Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
          übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf
          eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch
          erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
          entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
      </div>

      <!-- Haftung für Links -->
      <div class="bs-docs-section mb-5">
        <h3><i class="fas fa-link"></i> Haftung für Links</h3>
        <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
          Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
          Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden
          zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt
          der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
          konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden
          wir derartige Links umgehend entfernen.</p>
      </div>

      <!-- Urheberrecht -->
      <div class="bs-docs-section mb-5">
        <h3><i class="fas fa-copyright"></i> Urheberrecht</h3>
        <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
          Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen
          des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und
          Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
          dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere
          werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung
          aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
          wir derartige Inhalte umgehend entfernen.</p>
      </div>

      <!-- Bildmaterial -->
      <p>
        <b>Bildmaterial:</b><br>Wir beziehen das verwendete Bildmaterial aus unserem eigenen Content. Die Bildrechte
        liegen beim Urheber.<br><br></p>
      <p>Quelle: <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer">e-recht24.de</a></p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ImpressumComponent',
};
</script>

<style scoped>
/* Stil für die Überschrift und den Einleitungstext */
.intro-text h2 {
  font-size: 2.5rem;
  font-weight: bold;
  color: #3a3a3a;
  margin-bottom: 2rem; /* Erhöhter Abstand nach unten */
  margin-top: 3rem; /* Abstand nach oben */
}

h2 i {
  color: #e2a84b;
  margin-right: 10px;
}

.intro-text p {
  font-size: 1.2rem;
  color: #3a3a3a;
}

/* Überschriften */
h3 {
  font-size: 1.5rem;
  color: #3a3a3a;
}

h3 i {
  color: #e2a84b;
  margin-right: 10px;
}

/* Absatz und Links */
p {
  color: #3a3a3a;
  font-size: 1.1rem;
}

a {
  color: #e2a84b;
  text-decoration: none;
}

a:hover {
  color: #c75b29;
}

/* Container-Stil */
.container {
  background-color: #f8f9fa;
  padding: 2rem;
  border-radius: 10px;
}
</style>
